/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import scountApi from '@/services/scount-api';

const state = {
  calendar: null,
  responseStatus: null,
};

const mutations = {
  setCalendar(state, value) {
    state.calendar = value;
  },
  setResponseStatus(state, value) {
    state.responseStatus = value;
  },
};

const getters = {
  calendar: (state) => state.calendar,
  responseStatus: (state) => state.responseStatus,
};

const actions = {
  getCalendar({ commit }) {
    return scountApi.getCalendar()
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setCalendar', response.data);
        } else {
          commit('setCalendar', null);
        }
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
